export default class PageError {
    private readonly errorType: string;
    private readonly errorText: string;

    constructor (type: string, text: string) {
        this.errorType = type;
        this.errorText = text;
    }

    get type () {
        return this.errorType;
    }
    get text () {
        return this.errorText;
    }
}